import React from 'react'
import WebService from 'api/explus-api'
import MyChild from './MyChild'
import Loader from '../../Loader/Loader'

class MyChildContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      childData: '',
      partner: '',
      childVideo: '',
      childVideoSolo:'',
      loaded: false
    }

    this.handler = this.handler.bind(this)
  }


  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.handleCycleChange()
    }
  }

  componentDidMount() {
    this.handleCycleChange()
  }

  //---------------------------------------------------------------
  //- HANDLE FETCHING OF CHILD DATA DEPENDING ON COMPONENT CYCLE --
  //---------------------------------------------------------------
  handleCycleChange() {
    let childData = ''

    this.setState({loaded: false})

    this.getChildById(this.props.match.params.childId).then(data => {
      if (typeof data.status !== 'undefined' || data.status === 'error') {return}

      childData = data

      if (data.child) {
        WebService.getChildVideo(data.child.child_id).then(data => {
          this.setState({childVideo: data});
        })
      }

      if (data.child) {
        WebService.getChildVideoSolo(data.child.child_id).then(data => {

          // console.log('CUV:' +  data[2].url)
          this.setState({childVideoSolo: data});
        })
      }

      return this.getProjects(childData.childProjectId).then(data => {
        childData.project = data

        this.setState({childData})
        // this.setState({loaded: true})
        this.getChildImage(childData.child)
        // this.getPartner()
        this.checkCache('partner')

      })
    })
  }

  //---------------------------------------------------------------
  //------- HANDLE CHANGE CHILD PAGE ------------------------------
  //---------------------------------------------------------------
  handler(pageNumber) {
    return event => {
      event.preventDefault()
      let childData = ''

      if (pageNumber !== '') {
        this.setState({loaded: false})
      }

      return this.getChild(pageNumber).then(data => {

        if (typeof data.status !== 'undefined' || data.status === 'error') {return}
        childData = data

        return this.getProjects(childData.childProjectId).then(data => {
          childData.project = data
          this.setState({childData})
          this.setState({loaded: true})
          this.getChildImage(childData.child)
        })
      })
    }
  }

  extractProjectIdFromChild(childId) {
    if (!childId) {return}

    let projectId = ''
    projectId = childId.split('-')
    return projectId = projectId[0]
  }

  //---------------------------------------------------------------
  //------- GET PARTNER DETAILS -----------------------------------
  //---------------------------------------------------------------
  getPartner() {
    WebService.getPartner()
    .then(res => {
      const state = 'partner'
      this.setState({[state]: res})
      this.setState({loaded: true})
      sessionStorage.setItem(state, JSON.stringify(res))
    })
  }

  // check if cached version is available
  checkCache(cacheKey) {
    if (sessionStorage.getItem(cacheKey)) {
      this.setState({[cacheKey]: JSON.parse(sessionStorage.getItem(cacheKey))})
      this.setState({loaded: true})
    } else {
      switch (cacheKey) {
        case 'partner':
          this.getPartner()
          return
        default:
          return
      }
    }
  }

  //---------------------------------------------------------------
  //------- GET CHILD PHOTO ---------------------------------------
  //---------------------------------------------------------------
  getChildImage(child) {
    const id = '/' + child.child_id // 2 web optimised image

    WebService.ajaxGet('web/childphoto' + id).then(data => {

      let imageUrl = ''

      if (typeof data[2] !== 'undefined') {
        imageUrl = data[2].url
      }

      this.setState(prevState => ({childData: {
          ...prevState.childData, childPhoto: imageUrl }
      }))
    })
  }

  //---------------------------------------------------------------
  //------- GET CHILD BY ID ---------------------------------------
  //---------------------------------------------------------------
  getChildById(childId) {
    return WebService.getChildById(childId).then(data => {
      if (typeof data.data === 'undefined') {
        this.setState({errors: data})
        return {status: 'error'}
      }

      const fetchedData = {
        child: data.data[0],
        childProjectId: this.extractProjectIdFromChild(data.data[0].child_id),
        nextPage: data.next_page_url,
        prevPage: data.prev_page_url
      }

      return fetchedData
    })
  }

  //---------------------------------------------------------------
  //------- GET CHILD ---------------------------------------------
  //---------------------------------------------------------------
  getChild(urlWithPageNumber) {

    let endpoint = 1 // defaults to page 1

    if (typeof urlWithPageNumber !== 'undefined') {
      endpoint = urlWithPageNumber
    }

    return WebService.ajaxGet('web/children?per_page=1', endpoint).then(data => {

      if (typeof data.data === 'undefined') {
        this.setState({errors: data})
        return {status: 'error'}
      }

      const fetchedData = {
        child: data.data[0],
        childProjectId: this.extractProjectIdFromChild(data.data[0].child_id),
        nextPage: data.next_page_url,
        prevPage: data.prev_page_url
      }

      return fetchedData
    })
  }

  //---------------------------------------------------------------
  //------- GET PROJECT DETAILS -----------------------------------
  //---------------------------------------------------------------
  getProjects(childPid) {
    if (!childPid) {return}
    const pid = childPid

    return WebService.ajaxGet('web/projects/' + pid).then(data => {
      return data[0]
    })
  }

  //---------------------------------------------------------------
  //------- DISPLAY PRESENTATION COMPONENT ------------------------
  //---------------------------------------------------------------
  childData() {
    let content = ''
    const child = this.state.childData.child

    if (this.state.loaded === false) {
      return content = <Loader/>
    }
    if (typeof child === 'undefined') {return}

    content = <MyChild 
                  prevChild={this.state.childData.prevPage}
                  nextChild={this.state.childData.nextPage}
                  sponsor={this.state.partner} 
                  child={this.state.childData.child}
                  childVideo={this.state.childVideo}
                  childVideoSolo={this.state.childVideoSolo}
                  childPhoto={this.state.childData.childPhoto}
                  project={this.state.childData.project}
                  handler={this.handler} />
    return content
  }

  render() {
    return (
      <div>
        {this.childData()}
      </div>
    )
  }
}

export default MyChildContainer
